import { render, staticRenderFns } from "./SiteSearch.vue?vue&type=template&id=19a83964&scoped=true&"
import script from "./SiteSearch.vue?vue&type=script&lang=js&"
export * from "./SiteSearch.vue?vue&type=script&lang=js&"
import style0 from "./SiteSearch.vue?vue&type=style&index=0&id=19a83964&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a83964",
  null
  
)

export default component.exports